import { Link } from "react-router-dom";
import { BasePage, LinkButton } from 'components';
import { Grid, Box, Typography, Button } from '@mui/material';

export function NotFoundPage() {
    return (
        <BasePage title="Page Not Found">
            <Box noValidate>
                <Grid container spacing={2} justifyContent="center" alignItems="center" direction="column">
                    <Grid>
                        <Typography variant="body1">
                            Sorry, the page you're looking for doesn't exist.
                        </Typography>
                    </Grid>
                    <Grid size={12}>
                        <Button
                            component={Link}
                            to="/"
                            fullWidth
                            variant="contained"
                        >
                            Sign in
                        </Button>
                    </Grid>
                    <Grid size={12} className="form-actions">
                        <LinkButton to="/">Home</LinkButton>
                    </Grid>
                </Grid>
            </Box>
        </BasePage>
    )
}
